"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, ReactNode } from "react";
import { Translations, getTranslation } from "@/lib/translationHelpers";
interface TranslationsContextValue {
  translations: Translations;
  t: (key: string, fallback?: string) => string;
}
const TranslationsContext = createContext<TranslationsContextValue | undefined>(undefined);
interface TranslationsProviderProps {
  children: ReactNode;
  translations: Translations;
}

/**
 * Client-side provider that receives translations from server component
 * This follows Next.js 13+ best practices: load on server, provide to client
 */
export function TranslationsProvider(t0) {
  const $ = _c(8);
  const {
    children,
    translations
  } = t0;
  let t1;
  if ($[0] !== translations) {
    t1 = (key, fallback) => getTranslation(translations, key, fallback);
    $[0] = translations;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t = t1;
  let t2;
  if ($[2] !== t || $[3] !== translations) {
    t2 = {
      translations,
      t
    };
    $[2] = t;
    $[3] = translations;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const value = t2;
  let t3;
  if ($[5] !== children || $[6] !== value) {
    t3 = <TranslationsContext.Provider value={value}>{children}</TranslationsContext.Provider>;
    $[5] = children;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}

/**
 * Hook to access translations in client components
 * Usage: const { t } = useTranslations();
 * Example: t('theme.dark') or t('book appointment')
 */
export function useTranslations() {
  const context = useContext(TranslationsContext);
  if (!context) {
    throw new Error("useTranslations must be used within TranslationsProvider");
  }
  return context;
}